/**
 * The in-app path a notification link points to, or null for anything that is not a path on this
 * origin, so a notification can never navigate the app somewhere else.
 */
export function getInternalNotificationPath(actionUrl: string): string | null {
  if (!actionUrl.startsWith('/')) {
    return null;
  }

  try {
    const target = new URL(actionUrl, window.location.origin);
    if (target.origin !== window.location.origin) {
      return null;
    }

    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return null;
  }
}
